var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"text-align":"center","padding":"10px","font-size":"0.8 rem"}},[_vm._v("Building excellence together • Recognition View")])
}
var staticRenderFns = []

export { render, staticRenderFns }